// src/utils/eventUtils.js

// "2:00 PM" | "All Day" -> minutes since midnight, All Day sorts first (=-1)
export function parseDisplayTimeToMinutes(displayTime) {
  if (!displayTime || displayTime === "All Day") return -1;

  const [time, period] = displayTime.split(" ");
  let [h, m] = time.split(":").map(Number);

  if (period === "PM" && h !== 12) h += 12;
  if (period === "AM" && h === 12) h = 0;

  return h * 60 + m;
}

// "HH:MM" (24h) -> "h:mm AM/PM" | "All Day"
export function buildDisplayTimeFrom24h(startTime24h) {
  if (!startTime24h) return "All Day";

  const [h, m] = startTime24h.split(":").map(Number);
  const period = h >= 12 ? "PM" : "AM";
  const hour12 = h === 0 ? 12 : h > 12 ? h - 12 : h;

  return `${hour12}:${String(m).padStart(2, "0")} ${period}`;
}

// "HH:MM" + "HH:MM" -> "1 hour 15m" | "45m" | "" (invalid/negative/empty)
export function computeDurationFrom24hTimes(startTime24h, endTime24h) {
  if (!startTime24h || !endTime24h) return "";

  const [sh, sm] = startTime24h.split(":").map(Number);
  const [eh, em] = endTime24h.split(":").map(Number);

  const diffMinutes = eh * 60 + em - (sh * 60 + sm);
  if (diffMinutes <= 0) return "";

  const hours = Math.floor(diffMinutes / 60);
  const mins = diffMinutes % 60;

  if (hours > 0) {
    return `${hours} hour${hours > 1 ? "s" : ""}${mins > 0 ? ` ${mins}m` : ""}`;
  }
  return `${mins}m`;
}

// Sort helpers (do not mutate)
export function sortEventsByTime(events) {
  return [...events].sort(
    (a, b) => parseDisplayTimeToMinutes(a.time) - parseDisplayTimeToMinutes(b.time)
  );
}

const PRIORITY_RANK = { essential: 0, aware: 1, flexible: 2 };

function getEventPriority(event) {
  for (const tag of event.tags || []) {
    if (tag in PRIORITY_RANK) return PRIORITY_RANK[tag];
  }
  return 3; // untagged
}

export function sortEventsByPriorityThenTime(events) {
  return [...events].sort((a, b) => {
    const priDiff = getEventPriority(a) - getEventPriority(b);
    if (priDiff !== 0) return priDiff;
    return parseDisplayTimeToMinutes(a.time) - parseDisplayTimeToMinutes(b.time);
  });
}

export function filterEventsForDate(allEvents, day, month, year) {
  return allEvents.filter((e) => e.day === day && e.month === month && e.year === year);
}